import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Theme } from '../../components/theme-select/theme';
import { OverlayContainer } from '@angular/cdk/overlay';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  constructor(private overlayContainer: OverlayContainer) {
    overlayContainer.getContainerElement().classList.add(this.themeClass);

    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      const theme = JSON.parse(savedTheme) as Theme;
      this.changeTheme(theme);
    }
  }

  isDarkTheme$ = new BehaviorSubject<boolean>(false);
  themeChange$ = new BehaviorSubject<Theme>(new Theme('default-theme', false));
  themeClass = 'default-theme';

  changeTheme(theme: Theme) {
    localStorage.setItem('theme', JSON.stringify(theme));
    this.overlayContainer
      .getContainerElement()
      .classList.remove(this.themeClass);
    this.themeClass = theme.themeName;
    this.overlayContainer.getContainerElement().classList.add(this.themeClass);
    this.themeChange$.next(theme);
    this.isDarkTheme$.next(theme.isDark);
  }
}
